'use es6';

import { SLACK_USER } from 'reference-resolvers/constants/CacheKeys';
import { getSlackUsersByIds, getSlackUsersSearchPage, createGetSlackUsersByIds, createGetSlackUsersSearchPage } from 'reference-resolvers/api/SlackAPI';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
export const createSlackUserReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: SLACK_USER,
  createFetchByIds: createGetSlackUsersByIds,
  createFetchSearchPage: createGetSlackUsersSearchPage,
  fetchByIds: getSlackUsersByIds,
  fetchSearchPage: getSlackUsersSearchPage
}, options));
export default createSlackUserReferenceResolver();